export const ROUTES = {
  home: "home",
  hideAndSeek: "hideAndSeek",
  tokenFlip: "tokenFlip",
  rps: "rps",
  play1v1: "play1v1",
  play1v1Create: "play1v1Create",
  blackjack: "blackjack",
  roulette: "roulette",
  stats: "stats",
  leaderboard: "leaderboard",
  referrals: "referrals",
  accountDetails: "accountDetails",
  myNfts: "myNfts",
  login: "login",
  raffle: "raffle",
  disclaimer: "disclaimer",
  staking: {
    nuts: "stakingNuts",
    nfts: "stakingNfts",
  },
  nutsRoulette: "nutsRoulette",

  user: {
    // memesCreated: 'userMemesCreated', TODO: Can we support this somehow?
    memesWallet: "userMemesWallet",
    topMemesWallet: "userTopMemesWallet",
  },
  meme: {
    home: "memeHome",
    create: "memeCreate",
    view: "memeView",
    listTop: "memeListTop",
    listTopOlder: "memeListTopOlder",
    listOlder: "memeListOlder",
  },
  contests: {
    home: "contestsHome",
    create: "contestsCreate",
    view: "contestsView",
    entries: "contestsEntries",
  },
};

export const PATHS_EN = {
  [ROUTES.home]: "/",

  [ROUTES.hideAndSeek]: "/card-flip/:collection?",
  [ROUTES.tokenFlip]: "/token-flip/:collection?",
  [ROUTES.rps]: "/rps/:collection?",
  [ROUTES.play1v1]: "/battle-arena/:collection?",
  [ROUTES.play1v1Create]: "/battle-arena/create/:collection?",
  [ROUTES.blackjack]: "/blackjack",
  [ROUTES.roulette]: "/roulette",
  [ROUTES.stats]: "/stats",
  [ROUTES.leaderboard]: "/leaderboard",
  [ROUTES.referrals]: "/referrals",
  [ROUTES.raffle]: "/raffle",
  [ROUTES.myNfts]: "/my-nfts",
  [ROUTES.accountDetails]: "/account",
  [ROUTES.disclaimer]: "/legal-disclaimer",

  [ROUTES.staking.nuts]: "/staking/nuts",
  [ROUTES.staking.nfts]: "/staking/nfts/:collection?",

  [ROUTES.login]: "/connect-wallet",

  [ROUTES.nutsRoulette]: "/nuts-roulette",

  [ROUTES.user.memesWallet]: "/profile/:address/memes/wallet",
  [ROUTES.user.topMemesWallet]: "/profile/:address/top-memes/wallet",

  [ROUTES.meme.home]: "/memes",
  [ROUTES.meme.create]: "/meme/create",
  [ROUTES.meme.view]: "/meme/:nonce",
  [ROUTES.meme.listTop]: "/memes/top",
  [ROUTES.meme.listTopOlder]: "/memes/top/older/:period(\\d+)?",
  [ROUTES.meme.listOlder]: "/memes/older/:period(\\d+)?",

  [ROUTES.contests.home]: "/contests",
  [ROUTES.contests.create]: "/contests/create",
  [ROUTES.contests.view]: "/contests/:id",
  [ROUTES.contests.entries]: "/contests/:id/entries",
};
